<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="4.6154mm" height="5mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 10616 11500"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_674080096">
     <path class="fil0 str0" d="M0 1274l0 8953c0,247 81,432 180,616l132 186c106,113 198,212 346,292 37,20 65,39 103,55 132,59 324,124 513,124l5414 0c257,0 617,-137 803,-311 17,-16 21,-23 41,-39 46,-35 79,-79 118,-121l132 -186c40,-74 75,-138 101,-217 42,-128 79,-251 79,-399l0 -3150 -885 0 0 3061c0,292 -185,478 -478,478l-5237 0c-292,0 -477,-185 -477,-478l0 -8776c0,-293 184,-477 477,-477l2176 0 0 -885 -2264 0c-259,0 -618,137 -803,312 -113,106 -212,198 -291,346 -99,184 -180,369 -180,616z"/>
     <path class="fil0 str0" d="M5308 885l4423 0 0 3538 -2327 0c-42,0 -345,216 -385,243 -67,44 -125,83 -191,127 -62,41 -130,92 -193,126l0 -496 -1327 0 0 -3538zm-885 -36l0 3610c0,440 409,849 849,849l478 0 0 1265c43,-12 1675,-1110 1830,-1214 71,-47 53,-52 169,-51l1965 0c167,0 247,-23 364,-70 172,-69 308,-200 407,-353 73,-113 131,-267 131,-426l0 -3610c0,-440 -409,-849 -850,-849l-4494 0c-440,0 -849,409 -849,849z"/>
     <polygon class="fil0 str0" points="3538,9731 4423,9731 4423,8846 3538,8846 "/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Notification',
};
</script>

<style scoped>
.fil0 {fill:#666666}
.str0 {stroke:#666666;stroke-width:1}
</style>
